import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';
import { url } from 'utils/url';
import Axios from 'axios';

const baseUrl = url;
export const WEB_PAGES_FETCH = createAction('WEB_PAGES_FETCH');
export const WEB_PAGES_FETCH_DATA_SUCCESS = createAction(
  'WEB_PAGES_FETCH_DATA_SUCCESS'
);
export const WEB_PAGES_FETCH_DATA_FAIL = createAction(
  'WEB_PAGES_FETCH_DATA_FAIL'
);

export const WEB_PAGES_DELETE_INIT = createAction('WEB_PAGES_DELETE_INIT');
export const WEB_PAGES_DELETE_SUCCESS = createAction(
  'WEB_PAGES_DELETE_SUCCESS'
);
export const WEB_PAGES_DELETE_FAIL = createAction('WEB_PAGES_DELETE_FAIL');

export const WEB_PAGES_CLEAR_DATA = createAction('WEB_PAGES_CLEAR_DATA');

export const WEB_PAGES_CREATE_INIT = createAction('WEB_PAGES_CREATE_INIT');
export const WEB_PAGES_CREATE_SUCCESS = createAction(
  'WEB_PAGES_CREATE_SUCCESS'
);
export const WEB_PAGES_CREATE_FAIL = createAction('WEB_PAGES_CREATE_FAIL');

export const WEB_PAGES_MODIFY_INIT = createAction('WEB_PAGES_MODIFY_INIT');
export const WEB_PAGES_MODIFY_SUCCESS = createAction(
  'WEB_PAGES_MODIFY_SUCCESS'
);
export const WEB_PAGES_MODIFY_FAIL = createAction('WEB_PAGES_MODIFY_FAIL');

export const WEB_PAGES_CLEAN_UP = createAction('WEB_PAGES_CLEAN_UP');

export const WEB_PAGES_CLEAR_DATA_LOGOUT = createAction(
  'WEB_PAGES_CLEAR_DATA_LOGOUT'
);
export const WEB_PAGES_BULK = createAction('WEB_PAGES_BULK');

export const SET_WEB_PAGES = createAction('SET_WEB_PAGES');

export const fetchWebPages = () => {
  return async (dispatch, getState) => {
    dispatch(WEB_PAGES_FETCH());
    let webPagesData;
    try {
      webPagesData = await Axios.get(`${baseUrl}/webPages/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_PAGES_FETCH_DATA_FAIL({ error }));
    }
    const WEB_PAGES = { ...webPagesData.data };
    return dispatch(
      WEB_PAGES_FETCH_DATA_SUCCESS({
        list: getState().webPages.list,
        WEB_PAGES,
      })
    );
  };
};

export const addWebPages = (payload) => {
  return async (dispatch, getState) => {
    dispatch(WEB_PAGES_FETCH());
    try {
      webPagesData = await Axios.post(`${baseUrl}/webPages/create`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_PAGES_CREATE_FAIL({ error }));
    }
    return dispatch(WEB_PAGES_CREATE_SUCCESS());
  };
};

export const updateWebPages = (id, payload) => {
  return async (dispatch, getState) => {
    try {
      webPagesData = await Axios.put(
        `${baseUrl}/webPages/update/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_PAGES_MODIFY_FAIL({ error }));
    }
    return dispatch(WEB_PAGES_MODIFY_SUCCESS());
  };
};

export const deleteWebPages = (id, cb) => {
  return async (dispatch, getState) => {
    try {
      await Axios.delete(`${baseUrl}/webPages/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      cb && cb();
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('Failed', errorMessage);
      return dispatch(WEB_PAGES_DELETE_FAIL({ error }));
    }
    return dispatch(WEB_PAGES_DELETE_SUCCESS());
  };
};
